import React, { PropTypes } from 'react';

const BucketHeader = ({ title, logo: { src, alt } = {}, seeAllText }) => (
    <div className="collection__headerWrap">
        <h1>
            {title}
            {src && (
                <img
                    className="collection__headerWrap__logo"
                    src={src}
                    alt={alt}
                />
            )}
        </h1>
        <span className="see-all">
            {seeAllText}
        </span>
    </div>
);

BucketHeader.propTypes = {
    title: PropTypes.string,
    logo: PropTypes.object,
    seeAllText: PropTypes.string
};

export default BucketHeader;



// WEBPACK FOOTER //
// ./app/common/BucketHeader.js